import { render, staticRenderFns } from "./Floor2.vue?vue&type=template&id=3ca4ca9c"
import script from "./Floor2.vue?vue&type=script&lang=js"
export * from "./Floor2.vue?vue&type=script&lang=js"
import style0 from "./Floor2.vue?vue&type=style&index=0&id=3ca4ca9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports